// src/components/msteams-connect-button/DefaultMsTeamsConnectButton.tsx
import { useMemo } from "react";
import { Mounter } from "../Mounter.js";
import { jsx } from "react/jsx-runtime";
var DefaultMsTeamsConnectButton = (props) => {
  const {
    integrationIdentifier,
    connectionIdentifier,
    subscriberId,
    context,
    scope,
    connectionMode,
    autoLinkUser,
    onConnectSuccess,
    onConnectError,
    onDisconnectSuccess,
    onDisconnectError,
    connectLabel,
    connectedLabel
  } = props;
  const mountProps = useMemo(
    () => ({
      integrationIdentifier,
      connectionIdentifier,
      subscriberId,
      context,
      scope,
      connectionMode,
      autoLinkUser,
      onConnectSuccess,
      onConnectError,
      onDisconnectSuccess,
      onDisconnectError,
      connectLabel,
      connectedLabel
    }),
    [
      integrationIdentifier,
      connectionIdentifier,
      subscriberId,
      context,
      scope,
      connectionMode,
      autoLinkUser,
      onConnectSuccess,
      onConnectError,
      onDisconnectSuccess,
      onDisconnectError,
      connectLabel,
      connectedLabel
    ]
  );
  return /* @__PURE__ */ jsx(Mounter, { name: "MsTeamsConnectButton", props: mountProps });
};
export {
  DefaultMsTeamsConnectButton
};
//# sourceMappingURL=DefaultMsTeamsConnectButton.js.map